import styled, { css } from 'styled-components';

export const DiscountToggleLabelContainer = styled.div<{ countOnTheLeft?: boolean }>`
  min-height: 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;

  img:first-of-type {
    margin-right: 16px;
  }

  > span {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    padding-right: 8px;
    vertical-align: middle;
  }

  .checkbox-toggle-count {
    margin-right: 8px;
    color: ${({ theme }) => theme.kallisto.color.text.static.textSecondary};
    font-size: ${({ theme }) => theme.kallisto.font.size['175']};
    ${({ countOnTheLeft }) =>
      countOnTheLeft
        ? css`
            margin-left: 8px;
          `
        : css`
            margin-left: auto;
          `}
  }
`;
